"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPORTED_FILE_EXTENSIONS = exports.SUPPORTED_MIME_TYPES = void 0;
__exportStar(require("./auth"), exports);
__exportStar(require("./teachers"), exports);
__exportStar(require("./courses"), exports);
__exportStar(require("./coursePad"), exports);
__exportStar(require("./messages"), exports);
__exportStar(require("./notes"), exports);
__exportStar(require("./submissions"), exports);
__exportStar(require("./students"), exports);
__exportStar(require("./support"), exports);
__exportStar(require("./admin"), exports);
__exportStar(require("./marks"), exports);
__exportStar(require("./kvStore"), exports);
__exportStar(require("./xAPI"), exports);
exports.SUPPORTED_MIME_TYPES = [
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/bmp',
    'video/mp4',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'text/plain',
    'audio/mp3',
    'audio/aac',
];
exports.SUPPORTED_FILE_EXTENSIONS = [
    '.jpg',
    '.png',
    '.gif',
    '.bmp',
    '.mp4',
    '.pdf',
    '.doc',
    '.docx',
    '.txt',
    '.mp3',
    '.aac',
];
//# sourceMappingURL=index.js.map